export default __webpack_public_path__ + "static/media/playstore_button.8ed3670d.png";